import { AbstractMouseEvent } from './AbstractMouseEvent';
import { Mouse } from './Mouse';
import { CGSMouseEvent } from './MouseEvent';

export class MouseLongPressEvent extends AbstractMouseEvent {
  constructor(mouse: Mouse, event: CGSMouseEvent) {
    super(mouse, event);
  }
}

export enum SwipeDirection {
  left,
  right,
  up,
  down,
  unknown,
}

export enum WheelDirection {
  Horizontal,
  Vertical,
}
